export const HIRE_ROUTES = {
  home: "/hire/home",
  company: "/hire/company",
  talentNetwork: "/hire/talent-network",
  talentProfile: "/hire/talent-network/:id",
  shortlist: "/hire/shortlist",
  requestAHire: "/hire/request-a-hire",
  /** Home with the Request a meeting panel open (MeetingProvider reads ?meeting=1). */
  interviewStatus: "/hire/interview-status",
  unlocks: "/hire/unlocks/:feature",
  feedback: "/hire/feedback",
} as const;

export const hireTalentProfile = (id: string) => HIRE_ROUTES.talentProfile.replace(":id", id);
export const hireUnlock = (key: string) => HIRE_ROUTES.unlocks.replace(":feature", key);

/**
 * A PLG page (/signup… or /hire…). The app-wide Auth0 and Google OAuth wrappers skip these: PLG uses
 * neither, and adding a wrapper once the platform config loads would remount the page and lose its
 * state (a magic-link token, a Google / Microsoft sign-in result).
 */
export const isPlgPath = (pathname: string) => /^\/(signup|hire)(\/|$)/.test(pathname);

/** The marketing site, linked from the sign-in and US-only cards. */
export const PLG_SITE_URL = "https://www.onedge.co";
